"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getServiceTextTotSpeechRequestFromServiceAvatarRequest = exports.isTextToSpeechService = exports.isAvatarService = exports.ServiceProvider = void 0;
const providerTypes_1 = require("./providerTypes");
// Service providers
var ServiceProvider;
(function (ServiceProvider) {
    ServiceProvider["POLLY"] = "polly";
    ServiceProvider["POLLY_NEURAL"] = "polly-neural";
    ServiceProvider["GOOGLE"] = "google";
    ServiceProvider["WELLSAID"] = "wellsaid";
    ServiceProvider["ELEVENLABS"] = "elevenlabs";
    ServiceProvider["TAVUS"] = "tavus";
    ServiceProvider["DUMMY"] = "dummy";
})(ServiceProvider || (exports.ServiceProvider = ServiceProvider = {}));
const isAvatarService = (service) => {
    return service === ServiceProvider.TAVUS;
};
exports.isAvatarService = isAvatarService;
const isTextToSpeechService = (service) => {
    // todo - remove once TAVUS TTS is implemented
    return service !== ServiceProvider.TAVUS;
};
exports.isTextToSpeechService = isTextToSpeechService;
const getServiceTextTotSpeechRequestFromServiceAvatarRequest = (avatarRequest) => {
    return Object.assign({ service: avatarRequest.service }, (0, providerTypes_1.getTextToSpeechInputFromAvatarInput)(avatarRequest));
};
exports.getServiceTextTotSpeechRequestFromServiceAvatarRequest = getServiceTextTotSpeechRequestFromServiceAvatarRequest;
//# sourceMappingURL=serviceTypes.js.map